import styled from '@emotion/styled'

/**
 * RegionMap 공통 스타일 — 라우터 레벨에서 사용.
 *
 * 시도별 지도 시각은 각 SidoMap 컴포넌트(`maps/SeoulMap.tsx` 등)가 자체 스타일 보유.
 * 본 파일은 라우터의 wrapper와 공통 메시지 스타일만 담당.
 */

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
`

/** 두 줄 안내 메시지. white-space: pre-line으로 \n 처리 */
export const Message = styled.p`
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: -0.3px;
  color: #1f1f1f;
  text-align: center;
  white-space: pre-line;
`

export const MessageHighlight = styled.span`
  color: #ff5626;
`
